import { SxProps, Tag, TagList } from '@brandbank/portal-components';
import NiceModal from '@ebay/nice-modal-react';
import { useState } from 'react';
import { useUpdatePurposeIntent } from '../api';
import {
  PurposeIntentTag,
  UpdatePurposeIntentPayload,
} from '../purposeIntent.types';
import AddPurposeIntentModal from './AddPurposeIntentModal';

type PurposeIntentListSuccessProps = {
  purposeIntents: PurposeIntentTag[];
  purposeId: string;
  canEdit: boolean;
  sx?: SxProps;
};

const PurposeIntentListSuccess = ({
  purposeIntents,
  purposeId,
  canEdit,
  sx,
}: PurposeIntentListSuccessProps) => {
  const { mutateAsync, isLoading: mutateIsLoading } = useUpdatePurposeIntent();

  const [isLoading, setIsLoading] = useState(false);

  const handleAddNew = async () => {
    const newValue: UpdatePurposeIntentPayload | null = await NiceModal.show(
      AddPurposeIntentModal,
      {
        purposeId,
        currentTags: purposeIntents,
      }
    );

    if (newValue) {
      mutateAsync(newValue);
    }
  };

  const handleRemoveTag = async (tag: Tag) => {
    setIsLoading(true);
    await mutateAsync({ action: 'remove', purposeId, tagId: tag.id });
    setIsLoading(false);
  };

  const tags: Tag[] = purposeIntents?.map((intent) => ({
    id: intent.tagId,
    value: intent.description,
    color: intent.colour,
  }));

  return (
    <TagList
      value={tags}
      canEdit={canEdit}
      addNewLabel={tags?.length ? 'Add new feed tag' : 'Add feed tag'}
      handleAddNew={handleAddNew}
      handleRemoveTag={handleRemoveTag}
      disabled={isLoading || mutateIsLoading}
      sx={sx}
    />
  );
};

export default PurposeIntentListSuccess;
